<template>
  <!-- 充值弹窗 -->
  <el-dialog title=""
    :visible.sync="visible"
    class="add-card-dialog-components"
    :close-on-click-modal="false"
    :before-close="close"
    width="432px">
      <div class="content">
        <div class="content-title">添加银行卡</div>
        <div class="content-body">
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">选择银行</div>
            </el-col>
            <el-col :span="19">
              <div class="">
                  <el-select
                    v-model="formInline.bank"
                    :popper-append-to-body="false"
                    class="consumer-select"
                    placeholder="请选择银行卡"
                    size="medium"
                    clearable
                    style="width: 290px">
                   <el-option
                    v-for="(item,index) in cards"
                    :key="index"
                    :label="item.label"
                    :value="item.label">
                   </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">银行卡号</div>
            </el-col>
            <el-col :span="19">
              <div class="">
                  <el-input
                    v-model="formInline.card"
                    size="medium"
                    style="width:290px"
                    placeholder="请输入银行卡号"></el-input>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">姓名</div>
            </el-col>
            <el-col :span="19">
              <div class="">
                  <el-input
                    v-model="formInline.name"
                    size="medium"
                    style="width:290px"
                    placeholder="请输入开户姓名"></el-input>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">身份证号</div>
            </el-col>
            <el-col :span="19">
              <div class="">
                  <el-input
                    v-model="formInline.id_card"
                    size="medium"
                    style="width:290px"
                    placeholder="请输入身份证号"></el-input>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">手机号码</div>
            </el-col>
            <el-col :span="19">
              <div>
                  <el-input
                    :disabled="true"
                    size="medium"
                    style="width:290px"
                    v-model="userInfo.formatPhone"
                    placeholder=""></el-input>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">验证码</div>
            </el-col>
            <el-col :span="19">
              <div style="position:relative;">
                  <el-input
                    size="medium"
                    style="width:290px"
                    v-model="formInline.smscode"
                    placeholder="请输入验证码"></el-input>
                    <div class="send-btn" @click="setMessageCode">点击发送</div>
                    <div class="no-send-btn" v-if="messageSecond<configSecond">{{messageSecond}}秒后再次发送</div>
              </div>
            </el-col>
          </el-row>

        </div>
      </div>
      <div slot="footer"
         class="dialog-footer_one"
         @click="commit">
        <div>确认</div>
      </div>
  </el-dialog>

</template>

<script>
  import {bankList} from "@/util/config"
  import { mapState, mapMutations } from "vuex"
  // console.log("bankList: ",bankList);
  import { post } from "../../util/http";
  export default{
    computed: {
      ...mapState([
        "userInfo",
        "appConfig"
      ])
    },

    data(){
      return {
        messageTimeout:null,
        messageSecond : 0,
        configSecond : 60,
        visible : false,
        cards : [],
        formInline:{
          bank:"",
          card:"",
          name:"",
          id_card:"",
          smscode: ""
        }
      }
    },
    created(){
      this.cards = bankList;
      this.messageSecond = this.configSecond;
      // console.log("this.userInfo",this.userInfo);
    },
    destroyed(){
      clearInterval(this.messageTimeout);
    },
    methods: {
      open(){
        this.visible = true;
        this.messageSecond = this.configSecond;
        this.formInline = {
          bank:"",
          card:"",
          name:"",
          id_card:"",
          smscode: ""
        }
      },
      close(){
        this.visible = false;
        this.messageSecond = this.configSecond;
        clearInterval(this.messageTimeout);
      },
      check(){
        let can = true;
        return can;
      },
      commit(){
        console.log("this.formInline",this.formInline);
        let data ={
          ...this.formInline
        };
        post({
          url: "/api/user/addBank",
          data
        }).then(({ data: { data,status=1}})  => {
          this.close();
          if(status==0){
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success'
            });
            this.$emit("refresh");
          }else{
            this.$message({
              showClose: true,
              message: '添加失败',
              type: 'warning'
            });
          }

        })
        .catch(err=>{
          console.log("err",err);
        })
      },
      goSecond(){
        this.messageTimeout = setInterval(()=>{
          if(this.messageSecond<=0){
            clearInterval(this.messageTimeout)
            this.messageSecond = this.configSecond;
          }else{
            this.messageSecond--;
          }
        },1000)
      },
      setMessageCode() {
        let datainfo = {
          mobile: this.userInfo.account
        };
        post({
          url: "/api/user/sendVerifyCode",
          data: datainfo
        }).then(({ data: { data,status=1}})=>{
          if(status==0){
            this.goSecond();
            this.$message({
              showClose: true,
              message: '短信已发送',
              type: 'success'
            });
            this.$emit("refresh");
          }else{
            this.$message({
              showClose: true,
              message: '发送失败',
              type: 'warning'
            });
          }
        })
        .catch(err=>{
        })

      }


    }
  }
</script>

<style  scoped lang="stylus">
  .add-card-dialog-components{
    z-index:1;
    border-radius: 8px;
    /deep/{
      .el-dialog__header{
        padding-top : 0px;
      }
      .el-dialog__headerbtn .el-dialog__close{
        color : #999999;
        font-size : 24px;
      }
      .el-input--suffix .el-input__inner{
        background: #F7F7F7;
      }
      .el-input__inner{
        border-color : #f0f0f0 !important;
        //color : #333333 !important;
        &:hover{
          border-color : #f0f0f0 !important;
        }
      }
      .el-select .el-input.is-focus .el-input__inner{
        border-color : #f0f0f0;
      }
      .el-select .el-input__inner:focus{
        border-color : #f0f0f0;
      }
      .el-range-input {
        background: #f7f7f7 !important;
        //color: #333333 !important;
      }
      .el-date-editor {
        border-color : #f0f0f0 !important;
        background: #f7f7f7 !important;
      }
      .el-date-table td.start-date span, .el-date-table td.end-date span{
        // background-color : #26D99D !important;
      }
      .el-input__inner{
        background: #f7f7f7 !important;
        border-color : #f0f0f0;
        //color : #333333;
      }
      .el-input__inner:focus{
        border-color : #f0f0f0;
      }
      .el-select-dropdown__item{
        text-align : center;
      }
      .el-select-dropdown__item.selected,.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
        background-color : rgba(38,217,157,0.10);
        color: #333333;
      }
    }
    .el-row{
      padding : 10px 0px;
    }
    .content{
      padding : 30px;
      .content-title {
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 550;
        padding-bottom : 30px;
      }
      .label{
        height : 36px;
        line-height : 36px;
      }
      .no-send-btn,.send-btn{
        color : #ffffff;
        background: #DCB273;
        border-radius: 16px;
        position : absolute;
        padding : 5px 10px;
        right : 10px;
        top : 50%;
        transform : translateY(-50%);
        cursor : pointer;
      }
      .no-send-btn{
         background: #999999;
      }
    }

    .dialog-footer_one>div{
      height: 40px;
      background: #26D99D;
      border-radius: 20px;
    }

  }
</style>
